import { useQuery } from '@tanstack/react-query';
import { fetchEventDateRange } from '@/api/client';

/** A legkésőbbi aktív esemény dátuma — a dátum-csúszka felső határa. Nyelvfüggetlen, nem gyakran változik. */
export function useEventDateRange() {
  return useQuery({
    queryKey: ['event-date-range'],
    queryFn: fetchEventDateRange,
    staleTime: 5 * 60_000,
  });
}
